const sidebar_nav_ul = document.querySelector(".mobile-main-menu");

sidebar_nav_ul.querySelectorAll(".mobile-main-menu_li").forEach((li, index) => {
  li.addEventListener("click", (e) => {
    sidebar_nav_ul.querySelector(".active").classList.remove("active");
    li.classList.add("active");
    document.querySelector(".mobile-sub-menu.active").classList.remove("active");
    document.querySelectorAll(".mobile-sub-menu")[index].classList.add("active");
    if(!li.classList.contains("no_child")) {
      e.preventDefault();
    }
  });
});

// For deactive the backeground scroll when sidebar is open in iOS devices --> start
function iOS() {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform) ||
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
}

if (window.innerWidth < 641 && iOS()) {
  let scrollPosition = 0;

  // Function to save the current scroll position
  function saveScrollPosition() {
    scrollPosition = window.scrollY;
  }

  // Function to restore the saved scroll position
  function restoreScrollPosition() {
    window.scrollTo(0, scrollPosition);
  }

  document.querySelector("body").addEventListener("click", function (e) {
    const bodyElement = document.querySelector("body");
    if (e.target.closest('.Header__Icon[data-drawer-id="sidebar-menu"]')) {
      saveScrollPosition();
      setTimeout(() => {
        bodyElement.style.minHeight = "";
        bodyElement.classList.add("pause-background-scroll");
      }, 500);
    } else if (e.target.closest("#sidebar-menu .Drawer__Close")) {
      bodyElement.classList.remove("pause-background-scroll");
      bodyElement.style.minHeight = "auto";
      restoreScrollPosition();
    }
  });
}
// For deactive the backeground scroll when sidebar is open in iOS devices --> end